"use strict";
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
var __param = (this && this.__param) || function (paramIndex, decorator) {
    return function (target, key) { decorator(target, key, paramIndex); }
};
Object.defineProperty(exports, "__esModule", { value: true });
/**
 * Created by mariam.melkonyan on 5/18/17.
 */
const core_1 = require("@angular/core");
const categorical_chart_report_model_1 = require("./shared/categorical-chart-report.model");
const chart_type_model_1 = require("../../../controls/chart/shared/chart-type.model");
const idm_message_language_service_client_js_1 = require("@synisys/idm-message-language-service-client-js");
const categorical_chart_options_model_1 = require("./shared/categorical-chart-options.model");
const idm_session_data_provider_api_js_1 = require("@synisys/idm-session-data-provider-api-js");
const idm_dataset_service_client_js_1 = require("@synisys/idm-dataset-service-client-js");
const idm_common_util_frontend_1 = require("@synisys/idm-common-util-frontend");
const Observable_1 = require("rxjs/Observable");
const categorical_chart_model_1 = require("./shared/categorical-chart.model");
const main_settings_1 = require("../../shared/settings/main-settings");
const multilingual_type_helper_1 = require("../../../shared/multilingual-type-helper");
const idm_dynamic_controls_metadata_1 = require("@synisys/idm-dynamic-controls-metadata");
const path_processing_helper_1 = require("../../../shared/path-processing-helper");
const idm_ng_controls_1 = require("@synisys/idm-ng-controls");
const idm_page_service_client_js_1 = require("@synisys/idm-page-service-client-js");
const router_1 = require("@angular/router");
const store_1 = require("@ngrx/store");
const skynet_store_currencies_api_1 = require("@synisys/skynet-store-currencies-api");
const chart_sort_type_model_1 = require("./shared/chart-sort-type.model");
let CategoricalChartDesignerComponent = class CategoricalChartDesignerComponent extends main_settings_1.MainSettings {
    constructor(languageService, currentLanguageProvider, _pathService, _messageService, _datasetService, _pageNavigationService, _activatedRoute, store, communicationService) {
        super(communicationService);
        this.languageService = languageService;
        this.currentLanguageProvider = currentLanguageProvider;
        this._pathService = _pathService;
        this._messageService = _messageService;
        this._datasetService = _datasetService;
        this._pageNavigationService = _pageNavigationService;
        this._activatedRoute = _activatedRoute;
        this.store = store;
        this.datasetId = null;
        this.apply = new core_1.EventEmitter();
        this.ChartType = chart_type_model_1.ChartType;
        this.ChartSortType = chart_sort_type_model_1.ChartSortType;
        /**
         * All available measures for chart. Only Money and Number measures are available in chart.
         * @type {Array}
         * @private
         */
        this.availableMeasures = [];
        /**
         * All available, filtered categories.
         * @type {any[]}
         * @private
         */
        this.filteredCategories = [];
        /**
         * All available, filtered series.
         * @type {any[]}
         * @private
         */
        this.filteredSeries = [];
        /**
         * Flag that determines if the view is ready to render
         * @type {boolean}
         * @private
         */
        this.isReady = false;
        /**
         * The multilingual name of dataset.
         * @type {Map<number, string>}
         */
        this.datasetDtoName = null;
        /**
         * The current model of chart.
         * @type {null}
         */
        this.categoricalChartModel = null;
        /**
         * Options of dataSet combobox
         */
        this.datasetDtoComboboxOptions = [];
        this.pages = [];
        /**
         * One element array that contains the selected series. This field is used for series chip group.
         * @type {Array}
         * @private
         */
        this.selectedSeries = [];
        /**
         * The selected measures array. This field is used for series chip group.
         * @type {Array}
         * @private
         */
        this.selectedMeasures = [];
        /**
         * One element array that contains the selected category. This field is used for category chip group.
         * @type {Array}
         * @private
         */
        this.selectedCategories = [];
        this.categoricalChartOptionsChange = new core_1.EventEmitter();
        this.categoricalChartReportModelChange = new core_1.EventEmitter();
        /**
         * All available categories for chart. E. g. Documents are not available for chart.
         * @type {Array}
         * @private
         */
        this._availableCategories = [];
        this._chartOptionsEmitted = null;
        this._modelEmitted = null;
        idm_common_util_frontend_1.PreconditionCheck.notNullOrUndefined(languageService);
        idm_common_util_frontend_1.PreconditionCheck.notNullOrUndefined(_pathService);
        idm_common_util_frontend_1.PreconditionCheck.notNullOrUndefined(currentLanguageProvider);
        idm_common_util_frontend_1.PreconditionCheck.notNullOrUndefined(_messageService);
        idm_common_util_frontend_1.PreconditionCheck.notNullOrUndefined(_datasetService);
        idm_common_util_frontend_1.PreconditionCheck.notNullOrUndefined(_pageNavigationService);
        idm_common_util_frontend_1.PreconditionCheck.notNullOrUndefined(store);
        this.categoricalChartStateChange = new core_1.EventEmitter();
        this.messageSubscription = null;
    }
    get categoricalChartState() {
        return this._categoricalChartState;
    }
    /**
     * This property stores chart state, which we use to initialize control in case of dynamic forms.
     * Initializes categorical chart the first time.
     * @param categoricalChartState
     */
    set categoricalChartState(categoricalChartState) {
        categoricalChartState && categoricalChartState["state"] === "" && categoricalChartState["datasetId"] === "" && (categoricalChartState = null);
        this._categoricalChartState = categoricalChartState;
        this.initDatasetsComboboxOptions();
        !categoricalChartState && this.initializeOptionsFirstTime();
        categoricalChartState && (this.datasetId = categoricalChartState["datasetId"] !== "" ? categoricalChartState["datasetId"] : null);
        categoricalChartState && (this._categoricalChartModelState = categoricalChartState["state"]);
        categoricalChartState && (this._reportTitle = (!(categoricalChartState["title"]) ? null : multilingual_type_helper_1.MultilingualTypeHelper.deserializeMultilingualString(categoricalChartState["title"])));
        categoricalChartState && (this.isDataTableShowed = (!(categoricalChartState["isDataTableShowed"]) ? null : categoricalChartState["isDataTableShowed"]));
    }
    get selectedDatasetId() {
        return this._selectedDatasetId;
    }
    /**
     * Sets id of selected dataSet and resets state of categorical chart.
     * @param {number} selectedDatasetId
     */
    set selectedDatasetId(selectedDatasetId) {
        if (selectedDatasetId > 0) {
            this._selectedDatasetId = selectedDatasetId;
            this.datasetId = selectedDatasetId;
            this.createChartModelAndOptions(this._categoricalChartModelState);
            this.cloneChartInputs();
            this.loadPaths();
            this.loadDatasetById();
            this.stateToOutputs();
        }
    }
    get canBeStacked() {
        return this.categoricalChartOptions.chartType === chart_type_model_1.ChartType.COLUMN ||
            this.categoricalChartOptions.chartType === chart_type_model_1.ChartType.BAR;
    }
    ;
    ngOnChanges(changes) {
        let categoricalChartModelStateChanged = changes['categoricalChartState'];
        if (categoricalChartModelStateChanged && !categoricalChartModelStateChanged.isFirstChange() && (this.categoricalChartStateEmitted === null || this.categoricalChartState !== this.categoricalChartStateEmitted)) {
            this.initializeModelAndOptions();
            this.cloneChartInputs();
            this.loadPaths();
            this.loadDatasetById();
        }
    }
    cloneChartInputs() {
        this.categoricalChartReportModel = this.cloneCategoricalChartReportModel();
        this.categoricalChartReportModel.getChartReportModel()
            .subscribe(() => {
            this.onReportModelChanged();
            this.stateToOutputs();
        });
        //TODO: Fixed some model change bugs. Will be improved next week.
        this.categoricalChartReportModel.category = this.categoricalChartReportModel.category;
        this.categoricalChartOptions = this.cloneCategoricalChartOptions();
        this.categoricalChartOptions.getCategoricalChartOptions()
            .subscribe(() => {
            this.stateToOutputs();
        });
        this.categoricalChartModel.getCategoricalChartModel()
            .subscribe(() => {
            this.stateToOutputs();
        });
        this.hasChanges = false;
    }
    ngOnInit() {
        let languagesObservable = this.languageService.getAvailableLanguages();
        let currentLanguageObservable = this.currentLanguageProvider.getCurrentLanguage();
        Observable_1.Observable.zip(languagesObservable, currentLanguageObservable)
            .subscribe((data) => {
            this.languages = data[0];
            this.currentLanguage = data[1];
            this.isReady = true;
            this.datasetId && this.initializeModelAndOptions();
            this.datasetId && this.cloneChartInputs();
            this.datasetId && this.loadPaths();
            this.datasetId && this.loadDatasetById();
        });
        this.connect()
            .then(() => {
            this.resetReportTitleSubscription();
            this.resetIsDataTableShowedSubscription();
            !this.categoricalChartModel && this.createChartModelAndOptions(this._categoricalChartModelState);
        })
            .catch((err) => {
            console.warn("Failed with the following error: %o", err);
        });
    }
    /**
     * @inheritDoc
     */
    ngOnDestroy() {
        this.clearReportTitleSubscription();
        this.clearIsDataTableShowedSubscription();
    }
    changeChartType(chartType) {
        this.categoricalChartOptions.chartType = chartType;
    }
    updateCategories(selectedCategories) {
        const pathId = selectedCategories.length === 0 ? null : selectedCategories[0];
        pathId && this.setTimelineData(pathId);
        this.categoricalChartReportModel.category = pathId;
    }
    updateSeries(selectedSeries) {
        this.categoricalChartReportModel.series = (selectedSeries.length === 0) ? null : selectedSeries[0];
    }
    updateMeasures(selectedMeasures) {
        this.categoricalChartReportModel.measures = selectedMeasures;
    }
    swapCategoriesAndSeries() {
        const category = (this.selectedCategories.length === 0) ? null : this.selectedCategories[0];
        const series = (this.selectedSeries.length === 0) ? null : this.selectedSeries[0];
        series && this.setTimelineData(series);
        this.categoricalChartReportModel.category = series;
        this.categoricalChartReportModel.series = category;
    }
    setTimelineData(pathId) {
        const path = this.categoryPaths.get(pathId);
        if (path.categoryType === idm_dataset_service_client_js_1.CategoryType.DATE) {
            this.categoricalChartReportModel.setChartSortType(chart_sort_type_model_1.ChartSortType.TIME);
            this.categoricalChartReportModel.excludeUnspecified = true;
        }
        else {
            this.categoricalChartReportModel.setChartSortType(chart_sort_type_model_1.ChartSortType.CATEGORY_ASCENDING);
            this.categoricalChartReportModel.excludeUnspecified = false;
        }
    }
    getClasses(chartType) {
        return {
            "sis-chart-sidebar__icon--active": chartType === this.categoricalChartOptions.chartType
        };
    }
    /**
     * @override
     */
    stateToOutputs() {
        this.hasChanges = true;
        // Emit out chart state and store it.
        this.categoricalChartModel.categoricalChartOptions = this.categoricalChartOptions;
        this.categoricalChartModel.categoricalChartReportModel = this.categoricalChartReportModel;
        let title = (!this.reportTitle ? null : multilingual_type_helper_1.MultilingualTypeHelper.serializeMultilingualString(this.reportTitle));
        this.categoricalChartStateEmitted = {
            state: this.categoricalChartModel.toJsonString(this.languages),
            datasetId: this.datasetId,
            title: title,
            isDataTableShowed: this.isDataTableShowed
        };
        this.categoricalChartStateChange.emit(this.categoricalChartStateEmitted);
        this.sendPreviewMessageToParent();
    }
    loadPaths() {
        let pathGroupsPromise = this._pathService.getPathGroups(this.datasetId);
        let measurePathsPromise = this.loadChartMeasures();
        let categoryPathsPromise = this.loadChartCategories();
        Promise.all([pathGroupsPromise, measurePathsPromise, categoryPathsPromise]).then((data) => {
            this.pathGroups = data[0];
            this.measurePaths = data[1];
            this.categoryPaths = data[2];
            let availableRowCategoryPaths = new Map();
            let availableColumnMeasurePaths = new Map();
            // Filter paths for columns.
            path_processing_helper_1.extractAvailablePaths(data[1], availableColumnMeasurePaths);
            // Filter paths for rows.
            path_processing_helper_1.extractAvailablePaths(data[2], availableRowCategoryPaths);
            this.categoryPaths = availableRowCategoryPaths;
            this.measurePaths = availableColumnMeasurePaths;
            Observable_1.Observable.zip(this.currentLanguageProvider.getCurrentLanguage(), this._messageService.getMessage("reporting.controls.chart-designer.text.ungrouped"), Observable_1.Observable.from(this._pageNavigationService.getNavigation()), this._activatedRoute.params, skynet_store_currencies_api_1.getDefaultCurrency(this.store))
                .subscribe(([currentLanguage, message, pages, params, defaultCurrency]) => {
                let pageId = params["pageId"];
                this.currentLanguage = currentLanguage;
                this.defaultCurrencyId = defaultCurrency.id;
                this.pages = path_processing_helper_1.processPageItems(pageId, pages, this.currentLanguage.getId());
                this.processPaths(message);
            });
        });
    }
    /**
     * Loads dataSet name by dataSet id.
     */
    loadDatasetById() {
        idm_common_util_frontend_1.PreconditionCheck.notNullOrUndefined(this.datasetId);
        this._datasetService.getDataset(this.datasetId)
            .then((datasetDto) => {
            this.datasetDtoName = datasetDto.name;
        });
    }
    loadDatasets() {
        return this._datasetService.getDatasets();
    }
    /**
     * Creates combo box options for dataSet combo box.
     */
    initDatasetsComboboxOptions() {
        this.loadDatasets()
            .then((datasetDtos) => {
            let options = [];
            datasetDtos.forEach((datasetDto) => {
                options.push(new idm_ng_controls_1.ComboboxOption(datasetDto.id, datasetDto.name));
            });
            this.datasetDtoComboboxOptions = options;
        });
    }
    processPaths(unGroupedMessage) {
        this._availableCategories = path_processing_helper_1.initGroupedComboOptions(this.categoryPaths, this.pathGroups, this.currentLanguage, unGroupedMessage);
        this.availableMeasures = path_processing_helper_1.initGroupedComboOptions(this.measurePaths, this.pathGroups, this.currentLanguage, unGroupedMessage, undefined, this.defaultCurrencyId);
        this.onReportModelChanged();
    }
    loadChartMeasures() {
        let pathsPromise = this._pathService.getPaths(this.datasetId);
        return pathsPromise.then((paths) => {
            let measurePaths = paths.measurePaths;
            let chartMeasurePaths = new Map();
            measurePaths.forEach((measurePath, key) => {
                chartMeasurePaths.set(key, measurePath);
            });
            return chartMeasurePaths;
        });
    }
    loadChartCategories() {
        let pathsPromise = this._pathService.getPaths(this.datasetId);
        return pathsPromise.then((paths) => {
            let categoryPaths = paths.categoryPaths;
            let chartCategoryPaths = new Map();
            categoryPaths.forEach((categoryPath, key) => {
                chartCategoryPaths.set(key, categoryPath);
            });
            return chartCategoryPaths;
        });
    }
    /**
     * Updates the selected items according to report the model(for re-rendering chip groups)
     */
    onReportModelChanged() {
        let selectedSeriesId = this.categoricalChartReportModel.series;
        // If series is selected, only one measure is allowed in report
        selectedSeriesId !== null ? this.measureMaxCount = 1 : this.measureMaxCount = 15;
        this.filteredCategories = path_processing_helper_1.filterGroupedDataBySelectedItemId(this._availableCategories, selectedSeriesId);
        this.selectedCategories = this.categoricalChartReportModel.category ? [].concat(this.categoricalChartReportModel.category) : [];
        let selectedCategoryId = this.categoricalChartReportModel.category;
        this.filteredSeries = path_processing_helper_1.filterGroupedDataBySelectedItemId(this._availableCategories, selectedCategoryId);
        this.selectedSeries = this.categoricalChartReportModel.series ? [].concat(this.categoricalChartReportModel.series) : [];
        this.selectedMeasures = this.categoricalChartReportModel.measures ? path_processing_helper_1.setCurrenciesOfMeasures(this.availableMeasures, this.categoricalChartReportModel.measures) : [];
    }
    cloneCategoricalChartReportModel() {
        let categoricalChartReport = new categorical_chart_report_model_1.CategoricalChartReportModel();
        categoricalChartReport.deserialize(this.categoricalChartReportModel.serialize());
        return categoricalChartReport;
    }
    cloneCategoricalChartOptions() {
        let categoricalChartOptions = new categorical_chart_options_model_1.CategoricalChartOptions();
        categoricalChartOptions.deserialize(this.categoricalChartOptions.serialize(this.languages), this.languages);
        return categoricalChartOptions;
    }
    /**
     * This method initialize chart report model and options based on received string state
     */
    initializeModelAndOptions() {
        this.categoricalChartModel = new categorical_chart_model_1.CategoricalChartModel();
        this.categoricalChartModel.fromJsonString(this._categoricalChartModelState, this.languages);
        this.categoricalChartReportModel = this.categoricalChartModel.categoricalChartReportModel;
        this.categoricalChartOptions = this.categoricalChartModel.categoricalChartOptions;
    }
    /**
     * Initializes chart options and chart report model for the first time
     */
    initializeOptionsFirstTime() {
        this.categoricalChartReportModel = new categorical_chart_report_model_1.CategoricalChartReportModel();
        this.categoricalChartOptions = new categorical_chart_options_model_1.CategoricalChartOptions();
        this.categoricalChartOptions.selectedPaletteId = 0;
        this.categoricalChartOptions.chartType = chart_type_model_1.ChartType.COLUMN;
    }
    /**
     * These method create chart model with only filter component
     * @param state
     */
    createChartModelAndOptions(state) {
        this.categoricalChartModel = new categorical_chart_model_1.CategoricalChartModel();
        state && !this.languages && this.categoricalChartModel.chartWithFilterFromJsonString(this._categoricalChartModelState);
        state && this.languages && this.initializeModelAndOptions();
    }
};
__decorate([
    core_1.Input(),
    __metadata("design:type", String)
], CategoricalChartDesignerComponent.prototype, "id", void 0);
__decorate([
    core_1.Input(),
    __metadata("design:type", Number)
], CategoricalChartDesignerComponent.prototype, "datasetId", void 0);
__decorate([
    core_1.Output(),
    __metadata("design:type", core_1.EventEmitter)
], CategoricalChartDesignerComponent.prototype, "apply", void 0);
__decorate([
    core_1.Input(),
    __metadata("design:type", categorical_chart_options_model_1.CategoricalChartOptions)
], CategoricalChartDesignerComponent.prototype, "categoricalChartOptions", void 0);
__decorate([
    core_1.Input(),
    __metadata("design:type", categorical_chart_report_model_1.CategoricalChartReportModel)
], CategoricalChartDesignerComponent.prototype, "categoricalChartReportModel", void 0);
__decorate([
    core_1.Output(),
    __metadata("design:type", core_1.EventEmitter)
], CategoricalChartDesignerComponent.prototype, "categoricalChartOptionsChange", void 0);
__decorate([
    core_1.Output(),
    __metadata("design:type", core_1.EventEmitter)
], CategoricalChartDesignerComponent.prototype, "categoricalChartReportModelChange", void 0);
__decorate([
    core_1.Output("stateChange"),
    __metadata("design:type", core_1.EventEmitter)
], CategoricalChartDesignerComponent.prototype, "categoricalChartStateChange", void 0);
__decorate([
    core_1.Input("state"),
    __metadata("design:type", Object),
    __metadata("design:paramtypes", [Object])
], CategoricalChartDesignerComponent.prototype, "categoricalChartState", null);
CategoricalChartDesignerComponent = __decorate([
    core_1.Component({
        
        selector: "categorical-chart-designer",
        styles: [require('./categorical-chart-designer.component.css')],
        template: require('./categorical-chart-designer.component.html')
    }),
    idm_dynamic_controls_metadata_1.ControlMetadata({
        template: "<categorical-chart-designer [id]='%{id}' [state]='%{state}' (stateChange)='%{stateChange}'></categorical-chart-designer>",
    }),
    __param(8, core_1.Optional()),
    __metadata("design:paramtypes", [idm_message_language_service_client_js_1.LanguageService,
        idm_session_data_provider_api_js_1.CurrentLanguageProvider,
        idm_dataset_service_client_js_1.PathService,
        idm_message_language_service_client_js_1.MessageService,
        idm_dataset_service_client_js_1.DatasetService,
        idm_page_service_client_js_1.PageNavigationService,
        router_1.ActivatedRoute,
        store_1.Store,
        idm_dynamic_controls_metadata_1.CommunicationService])
], CategoricalChartDesignerComponent);
exports.CategoricalChartDesignerComponent = CategoricalChartDesignerComponent;
//# sourceMappingURL=categorical-chart-designer.component.js.map